module.exports = __webpack_public_path__ + "static/img/20221201_02.076d6c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20221201_02.png
// module id = ZpK0
// module chunks = 0